import React, { Fragment, useState } from "react";
import { Avatar, Button, Col, Divider, Drawer, Layout, Popover, Row, Upload, Modal } from "antd";
import dummyImg from "../../../assets/image/dummy.png"
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    globalBrandConfigState,
    globalBrandModuleSettingState,
    globalNotificationState,
    globalUserDetailState
} from "../../../_common/global_state";
import { useProfileFunction } from "../../../pages/profile/function";
import useShared from "../../../_common/_shared";
import { useTranslation } from "react-i18next";
import { PlusOutlined, LockFilled } from "@ant-design/icons";
import EditNavigationModal_2 from "./editNavigationModal";

const { Sider } = Layout;

export const Sider_2 = ({ routes }) => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const { IconModule } = useShared()
    const { updateProfile } = useProfileFunction()

    const [openEditNavModal, setOpenEditNavModal] = useState(false)
    const [openMorePopover, setIsOpenMorePopOver] = useState(false)
    const [hovered, setHovered] = useState(false);
    const [openDrawers, setOpenDrawers] = useState([]);

    const setNotificationMessage = useSetRecoilState(globalNotificationState)
    const brandConfigState = useRecoilValue(globalBrandConfigState)
    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState)
    const userDetails = useRecoilValue(globalUserDetailState)

    const uploadImage = async (e) => {
        const link = e?.file?.response?.data?.[0]
        if (link) {
            await updateProfile(userDetails?._id, {
                profileImage: link.toString(),
            })
        }
    }

    const categories = [...new Set(routes.flatMap(route => {
        if (route?.sub && !!route?.sub.length && route?.key === "more") {
            return route?.sub.map(subRoute => subRoute?.categoryName);
        }
        return [];
    }))];

    const openDrawer = (drawerKey) => {
        setOpenDrawers(prevOpenDrawers => [...prevOpenDrawers, drawerKey]);
        document.querySelector(".setPopoverCustom + .ant-popover").style.overflowY = "hidden";
    };

    const closeDrawer = (drawerKey) => {
        setOpenDrawers(prevOpenDrawers => prevOpenDrawers.filter(key => key !== drawerKey));
        document.querySelector(".setPopoverCustom + .ant-popover").style.overflowY = "scroll";
    };

    const handleMouseEnter = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    const handleLockedItemClick = () => {
        Modal.confirm({
            title: t("Access Denied"),
            content: t("Please complete your account verification to access this feature."),
            okText: t("Verify Now"),
            cancelText: t("common.cancel"),
            okButtonProps: {
                className: "primary_btn",
                type: "default"
            },
            cancelButtonProps: {
                className: "secondary_btn",
            },
            style: {minWidth: 300},
            centered: true,
            getContainer: () => document.getElementById("layout-2"),
            onOk: () => {
                navigate("/account-verification");
            }
        });
    }

    return (
        <Sider width={80} id={"layout-sider"} collapsible breakpoint={"md"} collapsedWidth={"0"}>
            <Col span={24} className={"text-center mt-6 mb-4"}>
                <Upload
                    id={"upload-profile-image"}
                    name={"files"}
                    action={`${brandConfigState?.assetsURL}/api/upload/file`}
                    data={{
                        brand: brandConfigState?.assetsBrandName,
                        category: "profile"
                    }}
                    showUploadList={false}
                    beforeUpload={(file) => {
                        const isImage = file.type?.includes("image")
                        if (!isImage) {
                            setNotificationMessage({
                                status: "error",
                                title: "",
                                msg: t("errorMsg.type.invalidFileType"),
                                key: "invalidFileType",
                            });
                        }
                        return isImage || Upload.LIST_IGNORE;
                    }}
                    accept={"image/*"}
                    maxCount={1}
                    onChange={uploadImage}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    className={`upload-container ${hovered ? "hovered" : ""}`}
                >
                    <Avatar size={40} src={userDetails?.profileImage || dummyImg} />
                    <div className={"plus-overlay"}>
                        <PlusOutlined />
                    </div>
                </Upload>
            </Col>
            {routes?.map((route) => {
                const isLocked = route?.locked;

                if (route?.sub && !!route?.sub?.length) {
                    const moreContent = (
                        <>
                            {categories.map((category, index) => (
                                <Row id={"layout-sider-popover"} key={category}>
                                    {index === 0 ? (
                                        <Divider className="sidebarDivider" style={{ display: "none" }} />
                                    ) : (
                                        <Divider className="sidebarDivider" />
                                    )}
                                    <Col span={24} className={"mb-2"}>
                                        <p className={"sub-title"}><strong>{t(`common.${category}`)}</strong></p>
                                    </Col>
                                    {route?.sub
                                        ?.sort((a, b) => {
                                            const categoryOrder = {
                                                common: 1,
                                                finance: 2,
                                                others: 3,
                                            };

                                            const categoryComparison = categoryOrder[a.categoryName] - categoryOrder[b.categoryName];
                                            if (categoryComparison !== 0) {
                                                return categoryComparison;
                                            }

                                            return categoryOrder[a.key] - categoryOrder[b.key];
                                        })
                                        ?.filter(subRoute => subRoute?.categoryName === category)
                                        ?.map((subRoute, i) => {
                                            const filterModule = brandModuleSetting?.filter((item) => item?.isEnabled === true && subRoute?.label === item?.name)
                                            const drawerKey = `${subRoute?.label}`;
                                            const isDrawerOpen = openDrawers.includes(drawerKey);
                                            const isLocked = subRoute?.locked;

                                            if (filterModule && subRoute?.sub) return (
                                                <Fragment key={i}>
                                                    <Col
                                                        xs={12} lg={6}
                                                        className={"layout-sider-popover-btn text-center mb-2"}
                                                        style={subRoute?.locked ? { opacity: 0.5, position: "relative" } : {}}
                                                        onClick={() => {
                                                            if (subRoute?.locked) {
                                                                handleLockedItemClick();
                                                                return;
                                                            }
                                                            openDrawer(drawerKey);
                                                            document.querySelector(".setPopoverCustom + .ant-popover")?.scrollTo({
                                                                top: 0,
                                                            });
                                                        }}
                                                    >
                                                        {subRoute?.locked && <LockFilled style={{ position: "absolute", top: 0, right: 10, fontSize: "10px" }} />}
                                                        {subRoute?.icon}
                                                    </Col>
                                                    <Drawer
                                                        key={drawerKey}
                                                        id={"drawerContainer"}
                                                        onClose={() => closeDrawer(drawerKey)}
                                                        open={isDrawerOpen}
                                                        className={"popoverDrawer"}
                                                        getContainer={false}
                                                        width={384}
                                                        title={
                                                            <Row justify={"end"}>
                                                                <Button
                                                                    type={"link"}
                                                                    onClick={() => closeDrawer(drawerKey)}
                                                                >
                                                                    X
                                                                </Button>
                                                            </Row>
                                                        }
                                                        closeIcon={false}
                                                    >
                                                        <Row className={"text-center"}>
                                                            {subRoute?.sub
                                                                ?.map(subSubRoute => {
                                                                    let title = subSubRoute?.label.replace(".", "").replace(/[-\s/+]/g, "_").toLowerCase()
                                                                    return (
                                                                        <Col
                                                                            className={"mb-4 cursor-pointer"}
                                                                            key={subSubRoute?.label}
                                                                            xs={12}
                                                                            lg={6}
                                                                            style={subSubRoute?.locked ? { opacity: 0.5, position: "relative" } : {}}
                                                                            onClick={() => {
                                                                                if (subSubRoute?.locked) {
                                                                                    handleLockedItemClick();
                                                                                    return;
                                                                                }
                                                                                subSubRoute?.type === "_blank"
                                                                                    ? window.open(subSubRoute?.path, "_blank")
                                                                                    : navigate(subSubRoute?.path)
                                                                            }}
                                                                        >
                                                                            {subSubRoute?.locked && <LockFilled style={{ position: "absolute", top: 0, right: 10, fontSize: "10px" }} />}
                                                                            <IconModule
                                                                                iconName={subSubRoute?.label}
                                                                                className={"sidebarIcon"}
                                                                                title={title}
                                                                            />
                                                                        </Col>
                                                                    )
                                                                })}
                                                        </Row>
                                                    </Drawer>
                                                </Fragment>
                                            )

                                            return (
                                                <Col
                                                    key={i}
                                                    xs={12}
                                                    lg={6}
                                                    className={"layout-sider-popover-btn text-center mb-2"}
                                                    style={subRoute?.locked ? { opacity: 0.3, position: "relative" } : {}}
                                                    onClick={() => {
                                                        if (subRoute?.locked) {
                                                            handleLockedItemClick();
                                                            return;
                                                        }
                                                        subRoute?.type === "_blank" ? window.open(subRoute?.path, "_blank") : navigate(subRoute?.path)
                                                        setIsOpenMorePopOver(false)
                                                    }}
                                                >
                                                    {subRoute?.locked && <LockFilled style={{ position: "absolute", top: 0, right: 10, fontSize: "10px" }} />}
                                                    {subRoute?.icon}
                                                </Col>
                                            );
                                        })
                                    }
                                </Row>
                            ))}
                            {route?.key === "more" && (
                                <Col span={24} className={"text-center editNavigation"}>
                                    <Divider style={{ margin: "0.2rem 0", background: "var(--divider-color)" }} />
                                    <Button
                                        type={"link"}
                                        onClick={() => {
                                            setOpenEditNavModal(true)
                                            setIsOpenMorePopOver(false)
                                        }}
                                    >
                                        {/*Edit Navigation*/}
                                        {t("common.editNavigation")}
                                    </Button>
                                </Col>
                            )}
                            {/*</div>*/}
                        </>
                    );

                    const content = (
                        <Row id={"layout-sider-popover"}>
                            {route?.sub?.map(subRoute => (
                                <Col
                                    key={subRoute?.label}
                                    xs={12}
                                    lg={6}
                                    className={`layout-sider-popover-btn text-center ${route?.sub?.length > 4 ? "mt-1 mb-2" : "mb-0"}`}
                                    style={subRoute?.locked ? { opacity: 0.5, position: "relative" } : {}}
                                    onClick={() => {
                                        if (subRoute?.locked) {
                                            handleLockedItemClick();
                                            return;
                                        }
                                        subRoute?.type === "_blank" ? window.open(subRoute?.path, "_blank") : navigate(subRoute?.path)
                                    }}
                                >
                                    {subRoute?.locked && <LockFilled style={{ position: "absolute", top: 0, right: 10, fontSize: "10px" }} />}
                                    {subRoute?.icon}
                                </Col>
                            ))}
                        </Row>
                    );

                    if (route?.key === "more") return (
                        <Popover
                            open={openMorePopover} destroyTooltipOnHide
                            className={"setPopoverCustom"} content={moreContent}
                            getPopupContainer={triggerNode => triggerNode.parentElement}
                            placement={"right"}
                            trigger="hover"
                            onOpenChange={(bool) => setIsOpenMorePopOver(bool)}
                        >
                            <Col span={24} className={"text-center mb-2 cursor-pointer"}>
                                {route?.icon}
                            </Col>
                        </Popover>
                    )

                    return (
                        <Popover
                            destroyTooltipOnHide
                            content={content}
                            placement={"right"}
                            getPopupContainer={triggerNode => triggerNode.parentElement}
                        >
                            <Col span={24} className={"text-center mb-2 cursor-pointer"}>
                                {route?.icon}
                            </Col>
                        </Popover>
                    )
                }

                return (
                    <Col
                        span={24}
                        className={"text-center mb-4 cursor-pointer"}
                        key={route?.label}
                        style={route?.locked ? { opacity: 0.3, position: "relative" } : {}}
                        onClick={() => {
                            if (route?.locked) {
                                handleLockedItemClick();
                                return;
                            }
                            route?.type === "_blank" ? window.open(route?.path, "_blank") : navigate(route?.path)
                        }}
                    >
                        {route?.locked && <LockFilled style={{ position: "absolute", top: 0, right: 10, fontSize: "10px" }} />}
                        {route?.icon}
                    </Col>
                )
            })}
            <EditNavigationModal_2 isModalOpen={openEditNavModal} handleCancel={() => setOpenEditNavModal(false)} />
        </Sider>
    )
}